.sendButtonIcon {
  color: var(--send-button-icon-color);
}
